import { Updatable } from '../../..';
import { PaymentGatewayTaxType } from '../PaymentGatewayInfo';

export default class RoboKassaKzSettings extends Updatable {
    public mrchLogin: string;
    public mrchPassword1: string;
    public mrchPassword2: string;
    public enableKassa: boolean = false;
    public isTest: boolean = false;
    public tax: PaymentGatewayTaxType = PaymentGatewayTaxType.None;

    update(entity: Partial<RoboKassaKzSettings>, allowUndefined = false) {
        super.update(entity, allowUndefined);
    }
}
